export default __webpack_public_path__ + "static/media/51_desktop.cfa07ca5.jpg";